import { render, staticRenderFns } from "./editFerienboerse.vue?vue&type=template&id=4ffdd626&scoped=true&"
import script from "./editFerienboerse.vue?vue&type=script&lang=js&"
export * from "./editFerienboerse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffdd626",
  null
  
)

export default component.exports